import React, {useEffect, useState} from "react";
import {useTitleFromComponent, useDataWithRoute} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {backupStatus} from "../../../utils/gridColumnDefs/backups/backupStatus";
import {useSearchParams} from "react-router-dom";
import {formatStockChartConfig} from "../../../utils/Helpers";
import AreaChart from "../../../components/AreaChart";
import {Card} from "reactstrap";

export default function BackupStatus({context, title}) {

    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const [chartData, setChartData] = useState([]);
    const [formattedChartData, setFormattedChartData] = useState([]);
    const [chartConfig, setChartConfig] = useState([]);
    const [categories, setCategories] = useState([]);
    const [collectionDates, setCollectionDates] = useState([]);
    const [trendData, setTrendData] = useState([]);

    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/backup_protection_status_proc?client_id=${client.clientId}&period_id=${periodId}`)

    useEffect(() => {
        if (data && data.recordsets?.length > 0) {
            setChartData(data?.recordsets[0]);
            const cat = data.recordsets?.[2]?.map(d => {
                return d.status.replace('Z', '');
            });
            const dates = data.recordsets?.[3]?.map(d => {
                return Date.parse(d.collection_date.split('T')[0])
            });
            setCategories(cat);
            setCollectionDates(dates)

            let series = cat?.map(c => {
                return {
                    name: c,
                    data: dates?.map(d => {
                        return [d, data?.recordsets[1].filter(f => f.status.replace('Z', '') === c
                            && Date.parse(f.collection_date.split('T')[0]) === d).length]
                    })
                }
            });
            setFormattedChartData(series);
            setTrendData(data?.recordsets[1]);
        }
        setChartConfig({
            colors: ['#8ed600', '#ff8d02', '#E10000']
        });
    }, [data]);

    const filterChanged = (eventData) => {
        let jobs = [];
        eventData.api.forEachNodeAfterFilter(node => {
            jobs.push(node.data.backup_job_name);
        });
        let series = categories.map(c => {
                return {
                    name: c,
                    data: collectionDates.map(d => {
                        return [d, trendData.filter(f => f.status.substring(1) === c && Date.parse(f.collection_date.split('T')[0]) === d
                            && jobs.includes(f.backup_job_name)).length]
                    })
                }
            })
        ;
        setFormattedChartData(series);
    };

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Backup Status</VsiH4>
        <VsiBubble>
            <AreaChart
                series={formattedChartData}
                categories={categories}
                stacking='percent'
                navDisabled={true}
                labelFormat={`{value}%`}
                config={chartConfig}
            />
        </VsiBubble>
        <VsiBubble>
            <Grid
                data={chartData}
                columnDefs={backupStatus}
                filterChanged={filterChanged}
            />
        </VsiBubble>

    </Card>
}
